import type { PropsWithChildren } from "react";
import { useState } from "react";

import { PremiumFeatureContactUsModal } from "app/pages/sales-intelligence/pages/premium-features/components/PremiumFeatureContactUsModal/PremiumFeatureContactUsModal";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

import type { IIntegrationCardButtonWrapperProps } from "./IntegrationButtonWrapper";
import IntegrationButtonWrapper from "./IntegrationButtonWrapper";

type Props = IIntegrationCardButtonWrapperProps & {
    hookId: string;
};

const IntegrationButtonWrapperWithFeatureRequest = ({
    hookId,
    onUpgradeClick,
    children,
    ...wrapperProps
}: PropsWithChildren<Props>) => {
    const [contactUsModal, setContactUsModal] = useState<boolean>(false);
    const handleUpgradeClick = () => {
        if (onUpgradeClick) {
            onUpgradeClick();
        }

        void requestFeature(hookId);
        setContactUsModal(true);
    };

    return (
        <>
            <IntegrationButtonWrapper
                {...wrapperProps}
                onUpgradeClick={handleUpgradeClick}
            >
                {children}
            </IntegrationButtonWrapper>

            <PremiumFeatureContactUsModal
                isOpen={contactUsModal}
                onClose={() => setContactUsModal(false)}
            />
        </>
    );
};

export default IntegrationButtonWrapperWithFeatureRequest;
